export const MAP_VOTE_DEFAULT_DURATION_SECONDS = 30;

export function resolveMapVoteDurationMs(durationSeconds) {
    const seconds = Number(durationSeconds);
    return (
        Number.isFinite(seconds) && seconds > 0
            ? seconds
            : MAP_VOTE_DEFAULT_DURATION_SECONDS
    ) * 1000;
}

/** Fraction of the original vote still left (1 = just started, 0 = expired). */
export function mapVoteRingProgress(remainingMs, durationSeconds) {
    const totalMs = resolveMapVoteDurationMs(durationSeconds);
    if (!Number.isFinite(remainingMs) || remainingMs <= 0) return 0;
    return Math.min(1, remainingMs / totalMs);
}
export const MAP_VOTE_PENDING_HEADING = "Map vote next";
export const MAP_VOTE_PENDING_HINT =
    "You'll pick the map after everyone accepts.";
export const MAP_VOTE_ACCEPT_HEADLINE = "Accept to continue";
export const MAP_VOTE_ACCEPTED_HEADLINE = "Accepted";
export const MAP_VOTE_ACCEPT_HEADLINE_SUFFIX = "— map vote is next";
export const MAP_VOTE_ALL_READY_LABEL = "All players ready";
export const MAP_VOTE_PREPARING_LABEL = "Preparing map vote";
/** Hold the vote overlay so the accept-stage handoff can land. */
export const MAP_VOTE_HANDOFF_MS = 560;
export const MAP_VOTE_STATUS_EYEBROW = "Map vote";
export const MAP_VOTE_STATUS_TITLE = "Choose your battleground";
export const MAP_VOTE_STATUS_SUBTITLE =
    "Highest votes win. Ties break at random.";
export const MAP_VOTE_LOADING_EYEBROW = "Loading match";
export const MAP_VOTE_LOADING_TITLE = "Preparing your server";
export const MAP_VOTE_LOADING_HINT = "Map locked. Connecting you to the match.";
/** Keep the vote overlay visible after a winner so loading can play until redirect. */
export const MAP_VOTE_RESOLVED_HOLD_MS = 25000;
